module.exports = __webpack_public_path__ + "static/media/hifi-02.3757ab53.png";